import { Injectable } from "@angular/core";
import { PrefixedRequestService } from "src/app/core/prefixed-request.service";
import { firstExistentValueFrom } from "src/utils";
import { HelpAssistEventCreation } from "./help-assist-event-creation.model";

@Injectable({ providedIn: "root" })
export class HelpAssistEventsService {
  public constructor(private readonly request: PrefixedRequestService) {}

  public async post(data: HelpAssistEventCreation): Promise<number> {
    const { id } = await firstExistentValueFrom(
      this.request.post({
        prefix: "site",
        path: "/TicketEvents",
        data,
      }),
    );
    return id;
  }
}
